// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"533":"8185c222","842":"34b9665a"}[chunkId] + ".js";
};